import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { SyncOptionsContactExport } from '../Enums/SyncOptionsContactExport.enum';

export class InputBenutzerSyncOptionAddModifyRelation<
  T extends EMode = EMode.entity
> {
  /** Alias: id */
  id?: string;
  /** Alias: userCode */
  userCode?: any;
  /** Alias: contactsExportMode */
  contactsExportMode?: SyncOptionsContactExport;
  /** Alias: contactsExportCustomer */
  contactsExportCustomer?: boolean;
  /** Alias: contactsExportSupplier */
  contactsExportSupplier?: boolean;
  /** Alias: contactsExportEmployees */
  contactsExportEmployees?: boolean;
  /** Alias: appointmentsSync */
  appointmentsSync?: boolean;
  /** Alias: appointmentsAllowPrivate */
  appointmentsAllowPrivate?: boolean;
  /** Alias: appointmentsSyncExternalAppointments */
  appointmentsSyncExternalAppointments?: boolean;
  /** Alias: mailboxId */
  mailboxId?: string;
  /** Alias: contactsIcludePrivateData */
  contactsIcludePrivateData?: boolean;
  /** Alias: appointmentsSyncPrivateItems */
  appointmentsSyncPrivateItems?: boolean;
  /** Alias: tenantCode */
  tenantCode?: number;

  __typename?: string;
}

const fields: FieldDefinitions<InputBenutzerSyncOptionAddModifyRelation> = {
  id: {
    alias: 'id',
  },
  userCode: {
    alias: 'userCode',
  },
  contactsExportMode: {
    alias: 'contactsExportMode',
  },
  contactsExportCustomer: {
    alias: 'contactsExportCustomer',
  },
  contactsExportSupplier: {
    alias: 'contactsExportSupplier',
  },
  contactsExportEmployees: {
    alias: 'contactsExportEmployees',
  },
  appointmentsSync: {
    alias: 'appointmentsSync',
  },
  appointmentsAllowPrivate: {
    alias: 'appointmentsAllowPrivate',
  },
  appointmentsSyncExternalAppointments: {
    alias: 'appointmentsSyncExternalAppointments',
  },
  mailboxId: {
    alias: 'mailboxId',
  },
  contactsIcludePrivateData: {
    alias: 'contactsIcludePrivateData',
  },
  appointmentsSyncPrivateItems: {
    alias: 'appointmentsSyncPrivateItems',
  },
  tenantCode: {
    alias: 'tenantCode',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputBenutzerSyncOptionAddModifyRelationEntityDefinition: EntitiyDefinition<InputBenutzerSyncOptionAddModifyRelation> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputBenutzerSyncOptionAddModifyRelation',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
